import React from 'react';

const AboutPage = () => {
  const [openIdx, setOpenIdx] = React.useState(0);

  const items = [
    {
      q: 'О нас',
      a: 'Japan Express — доставка и сопровождение заказов из Японии.\n\nПоддержка\nПн–Сб\n\nТрекинг\nВ реальном времени\n\nСклады\nKG · KZ',
    },
    {
      q: 'Как добавить номер телефона?',
      a: 'Перейдите в «Профиль» и сохраните номер телефона. Он нужен, чтобы связать заказы с вашим аккаунтом и показывать историю статусов.',
    },
    {
      q: 'Когда могу получить заказ?',
      a: 'Заказ можно забрать только при стастусе «Готов к выдаче». Для просмотра количество, веса и цен нажмите «Показать детали»',
    },
    {
      q: 'Сроки доставки',
      a: 'Сроки доставки 2 недели. В Зимний период до 3 недель',
    },
    {
      q: 'Есть ли инструкция по регистрации на Японские сайты?',
      a: 'Вы можете найти видеоуроки по регистрации во вкладке «Видео Материалы»',
    },
    {
      q: 'Как оставить заявку на доставку на дом?',
      a: 'Доставка осуществляется от 1кг! Чтобы оставить заявку свяжитесь с Менеджером по Whatsapp номеру +996701500002. Сроки подачи заявок выставляются в группе Телеграмм каждую неделю.',
    },
    {
      q: 'Как оплатить за заказ?',
      a: 'Вы можете оплатить за заказ через QR код во вкладке «Реквизиты».',
    },
  ];

  return (
    <div className="min-h-screen bg-bg text-text-primary pb-20">
      <div className="px-4 pt-6 max-w-3xl mx-auto">
        <div className="rounded-2xl border border-stroke bg-surface backdrop-blur-md overflow-hidden">
          <div className="p-5">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Справка</div>
            <h1 className="mt-1 text-xl font-semibold tracking-tight">FAQ</h1>
            <p className="mt-2 text-sm text-text-secondary">Ответы на частые вопросы.</p>
          </div>

          <div className="border-t border-stroke">
            {items.map((it, idx) => {
              const isOpen = idx === openIdx;
              return (
                <div key={it.q} className={idx === 0 ? '' : 'border-t border-stroke'}>
                  <button
                    type="button"
                    onClick={() => setOpenIdx(isOpen ? -1 : idx)}
                    className={`w-full text-left px-5 py-4 transition ${
                      isOpen ? 'bg-gradient-to-r from-neon-yellow/10 via-white/3 to-neon-blue/10' : 'hover:bg-surface-hover'
                    }`}
                  >
                    <div className="font-semibold text-text-primary">{it.q}</div>
                    {isOpen ? (
                      <div className="mt-2 text-sm text-text-secondary opacity-90 whitespace-pre-line">{it.a}</div>
                    ) : null}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;

